module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "products"
  }, [_c('app-tab'), _vm._v(" "), (_vm.disabled) ? _c('div', {
    staticClass: "product-disabled"
  }, [_c('h1', {
    staticClass: "sorry-text",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v("Lo sentimos, este producto está desactivado  :(")])]) : _c('detail-product', {
    attrs: {
      "features": _vm.features,
      "images": _vm.images,
      "product-detail": _vm.productDetail,
      "disabled-btn": _vm.disabledBtn
    },
    on: {
      "warehouse-event": _vm.openModal,
      "select": _vm.selectFeature,
      "change-quantity": _vm.changeQuantity,
      "favorite-event": _vm.loadData,
      "product-added": _vm.openModalAction,
      "selected-unit": _vm.selectedUnit
    }
  }), _vm._v(" "), _c('tabs', {
    attrs: {
      "disabled-product": _vm.disabled,
      "products": _vm.products,
      "tabs": _vm.tabs,
      "select": _vm.select,
      "list-questions": _vm.listQuestions,
      "list-opinions": _vm.listOpinions,
      "id": _vm.idProduct
    },
    on: {
      "select": _vm.selectTab,
      "update": _vm.loadDataQuestion,
      "update-opinion": _vm.loadOpinion
    }
  }), _vm._v(" "), _c('warehouse-modal', {
    attrs: {
      "open-modal": _vm.dialogVisible,
      "id": _vm.productDetail.id
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }), _vm._v(" "), _c('modal-action', {
    attrs: {
      "currency": _vm.getCurrencySymbol,
      "dialog": _vm.dialog,
      "product": _vm.productModal
    },
    on: {
      "close": _vm.closeModalAction,
      "go-to": _vm.goToCar
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88b38bce","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Products.vue
// module id = 1147
// module chunks = 1